export function getdata() {
	let obj = {
		formdatajbxx: {
			bblb: "",
			cains: "",
			qij: "",
			cains2: "",
			qij2: ""
		},
		bblb: [
			{
				value: '34',
				label: '科目余额变动报表'
			},
			{
				value: '35',
				label: '科目余额变动报表12-15'
			},
			{
				value: '36',
				label: '利润表变动分析报告'
			},
			{
				value: '37',
				label: '利润表变动分析报告_全年'
			},
			{
				value: '38',
				label: '现金流量表变动分析报告'
			},
			{
				value: '39',
				label: '期间费用科目变动分析报告'
			}
		],
		formlistjbxx34Or36Or39: [
			{
				prop: "cains",
				label: "财务年度",
				type: "select",
				selectval: [],
			},
			{
				prop: "qij",
				label: "财务期间",
				type: "select",
				selectval: [],
			},
			{
				prop: "cains2",
				label: "往期财务年度",
				type: "select",
				selectval: [],
			},
			{
				prop: "qij2",
				label: "往期财务期间",
				type: "select",
				selectval: [],
			}
		],
		formlistjbxx35: [
			{
				prop: "cains",
				label: "财务年度",
				type: "select",
				selectval: [],
			},
			{
				prop: "qij",
				label: "期间比较",
				type: "select",
				selectval: [
					{
						label: "12期间",
						value: 12
					},
					{
						label: "13期间",
						value: 13
					},
					{
						label: "14期间",
						value: 14
					},
					{
						label: "15期间",
						value: 15
					}
				],
			},
			{
				type: "hidden"
			},
			{
				prop: "qij2",
				label: "VS",
				type: "select",
				selectval: [
					{
						label: "12期间",
						value: 12
					},
					{
						label: "13期间",
						value: 13
					},
					{
						label: "14期间",
						value: 14
					},
					{
						label: "15期间",
						value: 15
					}
				],
			}	
		],
		formlistjbxx37Or38: [
			{
				prop: "cains",
				label: "财务年度",
				type: "select",
				selectval: [],
			}
		]
	}
	return obj
}
